import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import './aboutSection.css';
import './aboutSectionMobile.css';

const AboutSection = (props) => {
  const pageContent = props['content'];
  const [{content, currentLanguage}, dispatch] = useDataValue();
  return <section className="about" id="about">
    <div className="photo"><img src={pageContent['photo']} /></div>
    <div className="pen"><img src={pageContent['pen']} /></div>
    <div className="content">
      <div className="name">{pageContent['name']}</div>
      <div className="introductions">
        {pageContent["introductions"].map(content => {
          return <div key={content["language"]} className={`introduction verticalText ${content["language"]} ${content['language'] === currentLanguage? 'mobile': ''}`}
            dangerouslySetInnerHTML={{
              __html: content["text"]
            }} />;
        })}
      </div>
    </div>
    <div className="decorateLine" />
  </section>;
}

export default AboutSection;